import React from "react";
import { Tile } from "./generic/Tile";

function Product({ product, onDelete, onToggleChecked }) {
  const handleUpdate = () => onToggleChecked({ checked: !product.checked });

  return (
    <Tile
      style={{
        backgroundColor: "#f5f389",
        maxWidth: "200px",
        opacity: product.checked ? 0.5 : 1,
      }}
      key={product.id}
      onClick={handleUpdate}
    >
      <span
        style={{
          overflowWrap: "break-word",
          maxWidth: "100%",
          fontStyle: product.checked ? "italic" : undefined,
        }}
        onClick={handleUpdate}
      >
        {product.name}
        {product.amount
          ? ` (${product.amount}${product.unit ? ` ${product.unit}` : "x"})`
          : ""}
      </span>
    </Tile>
  );
}

export default Product;
